import { buildApiUrl } from "../../config/urls";

const ANON_ID_KEY = "incooking_anon_id";

const FUNNEL_EVENTS = new Set([
  "funnel_register_view",
  "funnel_register_submit",
  "funnel_register_success",
  "funnel_login_view",
  "funnel_login_success",
  "funnel_subscription_view",
  "funnel_checkout_autostart",
  "funnel_checkout_click",
  "funnel_checkout_session_created",
  "funnel_checkout_redirect",
  "funnel_payment_success_view",
  "funnel_premium_activated",
]);

function randomId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `anon_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreateAnonId() {
  if (typeof window === "undefined") return null;
  try {
    let anonId = window.localStorage.getItem(ANON_ID_KEY);
    if (anonId) return anonId;
    anonId = randomId();
    window.localStorage.setItem(ANON_ID_KEY, anonId);
    return anonId;
  } catch (_err) {
    return null;
  }
}

export async function sendFunnelEventToBackend(eventName, props = {}) {
  if (typeof window === "undefined") return;
  if (!FUNNEL_EVENTS.has(eventName)) return;

  const anonId = getOrCreateAnonId();
  try {
    const response = await fetch(buildApiUrl("/analytics/event"), {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        event_name: eventName,
        anon_id: anonId,
        props: props || {},
      }),
    });
    if (!response.ok && process.env.NODE_ENV !== "production") {
      console.debug("[analytics] backend transport skipped", response.status);
    }
  } catch (_err) {
    if (process.env.NODE_ENV !== "production") {
      console.debug("[analytics] backend transport unavailable");
    }
  }
}
